// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 详情 GET /school/class/get */
export async function getSchoolOpenApiClassGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSchool_openAPI_classGetParams,
  options?: { [key: string]: any },
) {
  return request<API.SchoolClass>('/school/class/get', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 列表 GET /school/class/list */
export async function getSchoolOpenApiClassList(options?: { [key: string]: any }) {
  return request<API.SPageC2ABSchoolClassC2BB>('/school/class/list', {
    method: 'GET',
    ...(options || {}),
  });
}
